import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import ContentPage from "components/ContentPage"

const TopicOverview = ({ data }) => (
  <ContentPage heroSize="lg" {...data.page} />
)

export default TopicOverview

TopicOverview.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.shape(ContentPage.propTypes).isRequired,
  }).isRequired,
}

export const query = graphql`
  query TopicOverview($id: String!) {
    page: sanityTopicOverview(id: { eq: $id }) {
      ...ContentPageBase
    }
  }
`
